import { render, staticRenderFns } from "./OverallRiasecView.vue?vue&type=template&id=2468501f&scoped=true&"
import script from "./OverallRiasecView.vue?vue&type=script&lang=js&"
export * from "./OverallRiasecView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2468501f",
  null
  
)

export default component.exports